module.exports = __webpack_public_path__ + "media/images/icon/icon_gp-3da6afdf86eecdb74ab212d09b12ac02.png";